// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import $ from 'jquery';

// Import polyfill
import './utilities/polyfill';
import '../../node_modules/focus-visible/dist/focus-visible';

// Import map
import './map/_map';
import './map/_map-listing-page';

import './_back-top-top';
import './_cta';
import './_image-block';
import './_ellipsis';
import './_access-tools';
import './_header';
import './_footer';
import './_dropdown';
import './_image';
import './_filter';
import './_accordion';
import './_project-evaluation';
import './_submission-stage';
import './_search-listing-page';
import './_tag-box';
import './_file-upload';
import './_audit-portal';
import './_ipl-pdf';
import './_search-block';


/*! outline.js v1.2.0 - https://github.com/lindsayevans/outline.js/ */
(function(d) {
  var style_element = d.createElement('STYLE'),
    dom_events = 'addEventListener' in d,
    add_event_listener = function(type, callback) {
      // Basic cross-browser event handling
      if (dom_events) {
        d.addEventListener(type, callback);
      } else {
        d.attachEvent('on' + type, callback);
      }
    },
    set_css = function(css_text) {
      // Handle setting of <style> element contents in IE8
      !!style_element.styleSheet ? (style_element.styleSheet.cssText = css_text) : (style_element.innerHTML = css_text);
    };
  d.getElementsByTagName('HEAD')[0].appendChild(style_element);

  // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
  add_event_listener('mousedown', function() {
    set_css(':focus{outline:0}::-moz-focus-inner{border:0;}');
  });

  add_event_listener('keydown', function() {
    set_css('');
  });
})(document);
